module.exports = __webpack_public_path__ + "static/media/coding.d966f19b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/coding.svg
// module id = 230
// module chunks = 0